import {css} from 'lit';
export const styles = css`:host {
  --value-max-height: 110px;
  --white-space: pre-wrap;

  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  background: var(--body-bg);
  color: var(--dark-text-secondary);
  border-radius: var(--border-radius);
  text-align: left;
}

div {
  max-height: var(--value-max-height);
  white-space: var(--white-space);
  overflow: auto;
}

::slotted(button) {
  margin-top: 16px !important;
}

::slotted(button) {
  align-self: end;
}
`;
export default styles;
